module.exports = __webpack_public_path__ + "img/product_2.8cc0ed1.webp";